<template>
    <div class="mobile-menu">
        <a href="#" @click.prevent="back()" class="btn btn-light btn-icon-left btn-shadow text-uppercase album-action album-action--back-button album-action-is-mobile">
            <span class="material-icon icon-keyboard_arrow_left"/>
        </a>
        <ul class="mobile-menu__actions">
            <li v-if="+photo.free_download" class="mobile-menu__action">
                <button type="submit" @click="downloadPhotos(photo.id)" class="action-link">
                    <span class="material-icon icon-cloud_download"/>
                    <span class="action-link__txt">{{ $t('helpers.download_photo') }}</span>
                </button>
            </li>
            <li v-if="!+photo.not_for_sale" class="mobile-menu__action mobile-menu__action--favorite" :class="{'mobile-menu__action--disabled': isDisabled}">
                <a href="#" class="action-link" @click.prevent="handleFavorite">
                    <span class="material-icon" :class="isFavorite ? 'icon-indeterminate_check_box' : 'icon-library_add'"/>
                    <span class="action-link__txt">{{ $t(!isFavorite ? 'add_to_selected' : 'delete_from_selected') }}</span>
                </a>
            </li>
        </ul>
        <a href="#" v-if="!+photo.not_for_sale && products && products.length > 0" @click.prevent="next()" class="mobile-menu__btn -green">
            <span class="material-icon icon-add_shopping_cart"/>
        </a>
    </div>
</template>

<script>
  import MobileOrderStep1Menu from 'src/mixins/mobileOrderStep1MenuComponent';

  export default {
    mixins: [MobileOrderStep1Menu],
  };
</script>
